<template>
  <div
    :class="[
      'o-heading__page',
      { 'is-small': small },
    ]">
    <h1 class="o-heading__page--item">
      <template v-if="hasSlot">
        <slot />
      </template>
    </h1>
  <!-- /.o-heading__page --></div>
</template>

<script lang="ts">
import { defineComponent, useSlots, computed } from 'vue'

export default defineComponent({
  name: 'PageHeadingDefault',

  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const slots = useSlots()
    const hasSlot = computed(() => {
      const v = !!slots.default && slots.default().some(vnode => vnode.children || vnode.props)
      if (!v) {
        console.warn('Exception:\nPage heading slot is empty. Please provide content into the slot.')
      }
      return v
    })

    return {
      hasSlot,
    }
  },
})
</script>

<style lang="sass" scoped>
.o-heading__page
  $root: &
  & &--item
    line-height: 1.4
    color: $font-black
    font:
      size: $font-xx-huge
      weight: bold

  &.is-small
    #{$root}--item
      font-size: $font-huge

  +breakpoint
    #{$root}--item
      font-size: $font-xx-large

    &.is-small
      #{$root}--item
        font-size: $font-large
</style>
